import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from '../Button';
import {
  InputField, TinyMCEEditor
} from '../ReduxFormComponents';
import { CourseValidation } from '../../middlewares/formValidator';

const CoursesForm = (props) => (
  <form onSubmit={props.handleSubmit}>
    <Field name="Id" component={InputField} type="hidden" className="form-control" />
    <div className="row form-group">
      <div className="col-md-4">
        <label className="text-left">Courses Name</label>
        <div>
          <Field name="Name" component={InputField} type="text" className="form-control" />
        </div>
      </div>
      <div className="col-md-4">
        <label className="text-left">Duration</label>
        <div>
          <Field name="Duration" component={InputField} type="text" className="form-control" />
        </div>
      </div>
      <div className="col-md-4">
        <label className="text-left">Type (Note : Cram Class/ Cram Code )</label>
        <div>
          <Field name="Type" component={InputField} type="text" className="form-control" />
        </div>
      </div>
    </div>
    <div className="row form-group">
      <div className="col-md-6">
        <label className="text-left">Slug URL</label>
        <div>
          <Field name="SlugURL" component={InputField} type="text" className="form-control" />
        </div>
      </div>
      <div className="col-md-6">
        <label className="text-left">Thumbnail URL</label>
        <div>
          <Field name="ThumbnailURL" component={InputField} type="text" className="form-control" />
        </div>
      </div>
    </div>
    <div className="row form-group mt-2">
      <div className="col-md-6">
        <label className="text-left">OrderNumber</label>
        <div>
          <Field name="OrderNumber" component={InputField} type="text" className="form-control" />
        </div>
      </div>
    </div>
    <div className="form-group ">
      <label>Description</label>
      <div>
        <Field
          name="Description"
          className="form-control"
          component={TinyMCEEditor}
          minHeight={250}
          inlineEditor
        />
      </div>
    </div>
    <div className="py-2 mt-2">
      <Button
        type="submit"
        className="btn btn-sm btn-success"
        loading={props.formLoading}
        loadingText="Saving..."
        disabled={props.pristine}
      >
        <i className="fas fa-save mr-1" />
        Save
      </Button>
      <Button
        onClick={props.reset}
        className="btn btn-sm btn-outline-secondary ml-2"
        disabled={props.pristine}
      >
        <i className="fas fa-redo mr-1" />
        Reset
      </Button>
    </div>
  </form>
);

CoursesForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  pristine: PropTypes.bool.isRequired
};

CoursesForm.defaultProps = {
  formLoading: null,
  formError: null
};

const coursesForm = reduxForm({
  form: 'Courses Form',
  validate: CourseValidation,
  initialValues: {},
  enableReinitialize: false
})(CoursesForm);

const mapStateToProps = ({ courses }) => ({
  initialValues: courses.form
});

export default connect(mapStateToProps)(coursesForm);
